import { createContext } from 'react'

export const UserContext = createContext({
  userLogin: null,
  userRole: null,
  userId: null,
})
